import { render, staticRenderFns } from "./marqueeItem.vue?vue&type=template&id=d6f2cb4c&"
import script from "./marqueeItem.vue?vue&type=script&lang=js&"
export * from "./marqueeItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.10.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports